export const SITEMAX_STATIC_URL = 'https://smx-cdn.sitemax.app';
export const APRYZE_STATIC_URL = `${SITEMAX_STATIC_URL}/lib/webviewer`;
